import React from "react";
import { useTranslation } from "react-i18next";
import NavItem from "../../layout/NavItem";
// Icon
import {
  InsightsTwoTone,
  PeopleRounded,
  LocalMallRounded,
  MoveDownRounded,
  ShoppingCartCheckoutRounded,
  ContactMailRounded,
  TroubleshootRounded,
  AdminPanelSettingsRounded,
  SettingsRounded,
  RequestQuoteRounded,
  PriceCheckRounded,
  InventoryRounded,
} from "@mui/icons-material";
import { connect } from "react-redux";

const NevMenu = ({ _authUser }) => {
  const { t  } = useTranslation();

  return (
    <>
      {_authUser.role === 1 && (
        <NavItem
          title={t("dashboard")}
          path="/dashboard"
          icon={<InsightsTwoTone />}
        />
      )}
      {_authUser.role !== 3 && (
        <>
          <NavItem
            title={t("products")}
            icon={<LocalMallRounded />}
            child={[
              { title: t("products"), path: "products" },
              { title: t("categories"), path: "categories" },
            ]}
          />

          <NavItem
            title={t("inventory")}
            path="/inventory"
            icon={<InventoryRounded />}
          />

          <NavItem
            title={t("purchases")}
            icon={<ShoppingCartCheckoutRounded />}
            child={[
              { title: t("purchases"), path: "purchases" },
              { title: t("purchasesReturn"), path: "purchases-return" },
            ]}
          />
          <NavItem
            title={t("suppliers")}
            path="suppliers"
            icon={<ContactMailRounded />}
          />
          
          <NavItem
            title={t("customers")}
            icon={<ContactMailRounded />}
            child={[
              { title: t("customers"), path: "customers" },
              { title: t("customerAccount"), path: "customers/customer-account" },
            ]}
          />

          <NavItem
            title={t("expenses")}
            icon={<RequestQuoteRounded />}
            child={[
              { title: t("expenses"), path: "paybills" },
              { title: t("expenseTypes"), path: "expenses" },
            ]}
          />
          
          <NavItem title={t("sells")} path="sells" icon={<PriceCheckRounded />} />
          <NavItem
            title={t("stockTransfer")}
            path="stock-transfer"
            icon={<MoveDownRounded />}
          />
        </>
      )}
      {_authUser.role === 1 && (
        <>
          <NavItem
            title={t("reports")}
            icon={<TroubleshootRounded />}
            child={[
              { title: t("customerBalanceReport"), path: "customers/customer-balance-report" },
              { title: t("refundReport"), path: "refund-report" },
              { title: t("storeReport"), path: "store-report" },
              { title: t("productReport"), path: "product-report" },
              { title: t("purchaseReport"), path: "purchase-report" },
              { title: t("registerReport"), path: "register-report" },
              { title: t("expenseReport"), path: "expense-report" },
              { title: t("productsSellVolume"), path: "products-sell-volume" },
              { title: t("employeeReport"), path: "employee-report" },
              { title: t("topSelling"), path: "top-selling" },
              { title: t("return"), path: "return" },
            ]}
          />
          <NavItem title={t("users")} path="/users" icon={<PeopleRounded />} />
          <NavItem
            title={t("HR")}
            icon={<AdminPanelSettingsRounded />}
            child={[
              { title: t("pay bills"), path: "paybills" },
              { title: t("salary payment"), path: "salary-payment" },
              { title: t("salary history"), path: "salary-history" },
              { title: t("employee history"), path: "employee-history" },
            ]}
          />
          <NavItem
            title={t("settings")}
            icon={<SettingsRounded />}
            child={[
              { title: t("store"), path: "store-settings" },
              { title: t("default store"), path: "default-store" },
            ]}
          />
        </>
      )}
    </>
  );
};

//              {/* title: "POS Item", path: "pos-settings"*/ },
const mapStateToProps = (state) => ({
  _authUser: state.pos.authUser,
});

const mapActiontoProps = {};

export default connect(mapStateToProps, mapActiontoProps)(NevMenu);
